module.exports = __webpack_public_path__ + "static/image-01-a@2x-2aa138035be714be0a0460d67eebe746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/buzzfeed/image-01-a@2x.jpg
// module id = 327
// module chunks = 3627797113349 20562973939449 33019919093843